import { render, staticRenderFns } from "./courseListDefault.vue?vue&type=template&id=8238d268&scoped=true"
import script from "./courseListDefault.vue?vue&type=script&lang=js"
export * from "./courseListDefault.vue?vue&type=script&lang=js"
import style0 from "./courseListDefault.vue?vue&type=style&index=0&id=8238d268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8238d268",
  null
  
)

export default component.exports